module.exports = __webpack_public_path__ + "static/media/interviewtips.1f856e84.jpg";